import React from "react";
import Sdata from "../Data/Sdata";
function Sports() {
  return (
    <div>
        <div className="row my-3">
          <div className="col-lg-12">
            <div className="border pb-3">
              <h2 className="pt-3 me-2 ps-4 pb-4">
                <span className="a">SPORTS NEWS</span>
              </h2>
              <div className="row pt-2 px-3 pb-3">
                {Sdata.slice(0, 1).map((a) => (
                  <>
                    <div className="col-lg-12">
                      <div className="mb-2">
                        <>
                          <div className="d-flex border my-2">
                            <img className="w-50" height={200} src={a.image} />
                            <div className="mx-3 mt-2">
                              <a href="">
                                <h5 className="text-dark pe-0 fw-normal">
                                  {a.title}
                                </h5>
                              </a>
                              <p className="text-secondary fw-light des">
                                {a.description}
                              </p>
                              <div className="d-flex text-secondary">
                                <i class="bi bi-clock-fill fs-6"></i>
                                <p className="mb-3 ps-2">November 16 , 2017</p>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                    <div className="col-lg-12 pt-3">
                      <div className="row">
                        {Sdata.slice(1, 5).map((a) => (
                          <div className="col-lg-3">
                            <img className="w-100" src={a.image} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Sports;
